<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="title">
                <span>Seguros</span>
                <h1>Empresariales</h1>
                <div id="contactForm">
                    <label for="">Conoce más sobre soluciones de seguros</label>
                    <div id="hubcontactForm"></div>
                </div>
        </div>
        <div class="info">
                <h1>Seguro colectivo de Vida</h1>
                <p>Ofrezca a sus empleados la oportunidad de contar con un seguro de vida que les permita tener bienestar y
                tranquilidad.
                </p>
        </div>
        <div class="services">
            <center>
                <h1>Con el Seguro Colectivo de Vida sus empleados podrán:</h1>
                <div v-for="(slide, i) in slides" :key="i">
                    <div v-for="(service, y) in slide.service" :key="y">
                        <div class="service-img">
                            <div>
                                <img :src="service.img" alt="">
                                <p v-html="service.text"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Uno de sus mayores intereses como empresario es desarrollar acciones que le permitan elevar y mantener la calidad de vida de su recurso
                humano y su grupo familiar. Con el Seguro Colectivo de Vida de SURA, se respirará en su empresa un aire social y familiarmente responsable,
                asimismo, se verá un mejoramiento en el desempeño de sus empleados y en los resultados obtenidos.
                <br>
                <br>
                Este seguro tiene como beneficio para los asegurados un menor costo de la póliza por tratarse de una colectiva y la posibilidad de extenderlo a
                su grupo familiar, lo que genera en ellos un mayor sentido de pertenencia por la empresa. Tenga en cuenta además, que el respaldo
                económico que recibirá el empleado y su grupo familiar, minimiza la necesidad de acudir a temas legales con la empresa.
                <br>
                <br>
                Gracias a que el Seguro de Vida, se convierte en un capital de respaldo inmediato para cubrir eventos inesperados, se disminuyen solicitudes
                de préstamos y niveles de endeudamiento por parte de sus empleados, contribuyendo a mantener los niveles de productividad y
                sostenimiento de la empresa.
                </p>
            </center>
        </div>
        <div class="ofrecemos">
            <center>
                <h1>¿Qué te ofrecemos?</h1>
                <div class="carta-box">
                    <div v-for="(ofrece, i) in ofrecemos" :key="i" class="carta">
                        <div class="cara">
                            <div class="text"><p>{{ofrece.text}}</p></div>
                            <div :class="ofrece.classA"></div>
                            <img :src="ofrece.img" alt="">
                        </div>
                        <div class="cara detras">
                            <div class="text"><p>{{ofrece.texto}}</p></div>
                            <div :class="ofrece.classB"></div>
                            <img :src="ofrece.img" alt="">
                        </div>
                    </div>
                </div>
            </center>
        </div>
        <div class="slide-cobertura-opcional">
            <center><h1>Coberturas opcionales</h1></center>
            <VueSlickCarousel
            class="slider"
            ref="slick"
            :autoplay="true"
            :dots="true"
            :arrows="false">
                <div v-for="(slide, i) in coberturaOpcional" :key="i">
                    <div class="cobertura-principal-slide">
                        <div>
                            <img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt="">
                            <label for="">{{slide.label}}</label>
                        </div>
                       <p v-html="slide.p"></p>
                    </div>
                </div>
            </VueSlickCarousel>
        </div>
        <div class="connect">
            <img src="@/assets/bg-llamado-accion.webp" alt="">
            <h1>¿Qué empresas se pueden asegurar?</h1>
            <p>Aquellas empresas en la que se aseguren más de 7 empleados entre empleados y sus familias. Asimismo, cooperativas y fondos de empleados
            cuyos socios pertenezcan a la misma empresa. Contacte a su asesor para conocer si su empresa cumple con el perfil asegurable.</p>
        </div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'Seguro-Colectivo-vida',
    metaInfo() {
        return {
            title: 'Seguro colectivo de vida',
            titleTemplate: '%s | Interseguros',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: 'Ofrezca a sus empleados la oportunidad de contar con un seguro de vida que les permita tener bienestar y tranquilidad.'
            },
            {
                vmid: 'keywords',
                name: 'keywords',
                content: 'Asesor en riesgos laborales, intermediación ARL, Control de ARL, Seguros ARL, Administradora de Riesgo Laborales, Seguros Generales, Seguros Empresariales, Seguros Personales'
            },
            {
                vmid: 'image',
                name: 'image',
                content: require('@/assets/logo/logo.webp')
            },
            {
                vmid: 'robots',
                name: 'robots',
                content: 'index, follow'
            },
            {
                vmid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Interseguros'
            },
            {
                vmid: 'twitter:site',
                name: 'twitter:site',
                content: '@Interseguros'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Recibe asesoría para cotizar y contratar diferentes tipos de seguros para empresas.'
            },
            {
                vmid: 'twitter:image',
                name: 'twitter:image',
                content: require('@/assets/image-people.png')
            }]
        }
    },
    components: {
        Aliados,
        VueSlickCarousel
    },
    data() {
        return {
            ofrecemos: [
                {
                    img: require('@/assets/colectivo-de-vida/4.png'),
                    text: 'Plan Empresario SURA',
                    texto: 'Protege al asegurado principal y su grupo familiar: hijos, cónyuge o compañero(a), hermanos y progenitores. Es un producto muy completo que ofrece una cobertura integral.',
                    classA: 'blue',
                    classB: 'green'
                },
                {
                    img: require('@/assets/colectivo-de-vida/5.png'),
                    text: 'Plan Vida Integral',
                    texto: 'Este producto brinda la facilidad de tener en una sola póliza diferentes coberturas de varias soluciones de Seguros: Vida, Accidentes Personales y Renta diaria.',
                    classA: 'green',
                    classB: 'blue'
                },
                {
                    img: require('@/assets/colectivo-de-vida/6.png'),
                    text: 'Plan Vida Deudores',
                    texto: 'Si su empleado tiene un préstamo con alguna entidad o empresa, y él fallece o pierde de forma permanente el 50% o más de la capacidad laboral, por medio del Plan Vida Deudores se garantiza que el saldo de la deuda se cancela, evitando por un lado dificultades de la entidad para recuperar su dinero y por el otro lado dejarle a los herederos cuentas por pagar.',
                    classA: 'blue',
                    classB: 'green'
                },
                {
                    img: require('@/assets/colectivo-de-vida/7.png'),
                    text: 'Plan Vida Docentes',
                    texto: 'Este plan está orientado a docentes y personal administrativo que se encuentre vinculado a entidades educativas tanto públicas como privadas y a su grupo familiar. ',
                    classA: 'green',
                    classB: 'blue'
                }
            ],
            coberturaOpcional: [
                {
                    label: 'Invalidez, pérdida o inutilización por enfermedad o accidente',
                    p: 'Si como consecuencia de un accidente o una enfermedad quedas inválido, es decir, pierdes de forma permanente el 50% o más de tu capacidad laboral, La aseguradora pagará los porcentajes de valor asegurado, que hayas alcanzado a la fecha del siniestro.'
                },
                {
                    label: 'Muerte en un accidente',
                    p: 'Si el fallecimiento es como consecuencia de un accidente, le entregamos a los beneficiarios una indemnización adicional igual al valor asegurado de esta cobertura'
                },
                {
                    label: 'Invalidez, pérdida o inutilización por un accidente',
                    p: '¡El riesgo está en todas partes!, por lo que con esta cobertura opcional obtendrás un respaldo para que no pierdas tu calidad de vida en caso de que algún evento accidental te exija más gastos de los normales.'
                },
                {
                    label: 'Pérdida parcial de la capacidad laboral',
                    p: 'Si como consecuencia de un accidente de trabajo o una enfermedad laboral pierdes de forma permanente entre el 20% y el 49% de tu capacidad laboral, Se pagará un porcentaje del valor asegurado de la cobertura de vida igual al de la pérdida de capacidad laboral.'
                },
                {
                    label: 'Enfermedades graves',
                    p: 'Si en algún momento eres diagnosticado con alguna enfermedad grave, tendrás un respaldo económico suficiente para tu tratamiento, dependiendo del valor que asegures. Es necesario consultar la lista de enfermedades que cubrimos.'
                },
                {
                    label: 'Muerte accidental adicional (AP)',
                    p: 'En caso de que fallezcas a causa de un accidente, Se te entrega una indemnización adicional a la de la cobertura de vida.'
                },
                {
                    label: 'Invalidez accidental adicional (AP)',
                    p: 'Si como consecuencia de un accidente quedas inválido, Se te paga una indemnización para que cubras los gastos según el valor que elijas.'
                },
                {
                    label: 'Renta por incapacidad',
                    p: 'Si como consecuencia de un accidente o una enfermedad tu EPS o ARL te incapacitan temporalmente para trabajar, Se te pagará una renta diaria a partir del octavo día de incapacidad y hasta por noventa (90) días continuos o discontinuos dentro de la vigencia de la póliza. <br> Recuerda que esta cobertura está sujeta a los siguientes condicionantes:<br><br> <span>• La incapacidad dure más de siete días </span> <br> <span>• Lleves más de sesenta días de haber contratado esta cobertura</span>'
                },
                {
                    label: 'Renta por hospitalización',
                    p: 'Si como consecuencia de un accidente o una enfermedad eres hospitalizado, Se te pagará, desde el primer día una renta diaria.'
                },
                {
                    label: 'Auxilio por maternidad o paternidad',
                    p: 'Por el nacimiento y sobrevivencia, Se te pagará el valor asegurado en esta cobertura. En caso de adopción también puedes acceder a este beneficio.'
                },
                {
                    label: 'Auxilio funerario',
                    p: 'En caso de que fallezcas, tus beneficiarios recibirán una suma de dinero adicional a la cobertura principal de este seguro. De esta forma cubrirán los gastos funerario necesarios.'
                },
                {
                    label: 'Auxilio de repatriación',
                    p: 'En caso de que el asegurado lleve menos de 90 días en el exterior y muera, Se pagará a la persona encargada de la repatriación los costos en los que haya incurrido para este fin, dentro del límite del valor asegurado.'
                },
                {
                    label: 'Bono para educación',
                    p: 'En caso de fallecimiento Se pagará a los beneficiarios el valor asegurado que podrán usar para cubrir gastos de educación.'
                },
                {
                    label: 'Bono para adecuaciones del hogar',
                    p: 'Si como consecuencia de un accidente o una enfermedad, el empleado queda inválido, Se pagará el valor asegurado para adecuar la casa.'
                },
                {
                    label: 'Bono canasta',
                    p: 'En caso de invalidez o muerte, Se te hará entrega del dinero a ti o a tus beneficiarios, para que sea utilizado libremente.'
                }
            ],
            slides: [
                {
                    service: [
                        {
                            text: 'Contar con un capital de respaldo inmediato para cubrir eventos inesperados.',
                            img: require('@/assets/colectivo-de-vida/1.png')
                        },
                        {
                            text: 'Tener la posibilidad de extender la protección a su grupo familiar.',
                            img: require('@/assets/colectivo-de-vida/2.png')
                        },
                        {
                            text: 'Tener una tarifa estable a lo largo de la vida laboral.',
                            img: require('@/assets/colectivo-de-vida/3.png')
                        }
                    ]
                }
            ]
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>
<style>
    .cobertura-principal-slide > p > span {
        font-weight: bold;
        margin-left: 5em;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 25px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 5px;
        margin-bottom: 15px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
</style>

<style scoped>
    .title {
        background-image: url('../../../assets/servicios-empresariales-bg.png');
        padding: 200px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 300px;
        font-size: 40px;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 300px;
        margin-top: 10px;
        font-size: 18px;
    }
    .services {
        padding: 50px 300px;
        width: 100%;
    }
    .services > center {
        display: contents;
    }
    .services > center > div {
        display: inline-block;
        width: 100%;
    }
    .services > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 50px;
        font-size: 30px;
    }
    .services > center > div > div {
        display: inline-flex;
        width: 33.333333333%;
        float: left;
    }
    .services > center > div > div > .service-img {
        width: 100%;
    }
    .services > center > div > div > .service-img > div {
        position: relative;
        width: 100%;
        height: 100%;
        padding: auto;
        margin-bottom: 10px;
        transition: margin-top .5s ease-out 100ms;
    }
    .services > center > div > div > .service-img > div:hover {
        margin-top: -10px;
    }
    .services > center > div > div > .service-img > div >  img {
        width: 100%;
        height: auto;
    }
    .services > center > div > div > .service-img > div >  p {
        font-family: 'JR';
        font-size: 18px;
    }
    .texto {
        width: 100%;
        padding: 10px 300px;
    }
    .texto > .box-title {
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .texto > .box-title > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box {
        padding: 20px 20px;
        text-align: left;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        margin-bottom: 10px;
    }
    .texto > center > p {
        font-family: 'JR';
    }
    .texto > center > p > span{
        font-weight: bold;
    }
    .ofrecemos > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .ofrecemos > center > div {
        position: relative;
        perspective: 1000px;
    }
    .ofrecemos > center > div > div {
        margin-top: 30px;
        display: flex;
        float: left;
        width: 25%;
        transform-style: preserve-3d;
        transition: all 1s linear;
        margin-bottom: 60px;
    }
    .ofrecemos > center > div > div:hover {
        transform: rotateY(180deg);
    }
    .ofrecemos > center > div > div > div {
        position: relative;
        width: 100%;
        justify-content: center;
        align-items: center;
    }
    .ofrecemos > center > div > div > div > .blue {
        position: absolute;
        width: 300px;
        height: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        background-color: rgba(45, 79, 152, 0.7);
    }
    .ofrecemos > center > div > div > div > .green {
        position: absolute;
        width: 300px;
        height: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        background-color: rgba(101, 178, 74, 0.7);
    }
    .ofrecemos > center > div > div > div > img {
        width: 300px;
    }
    .ofrecemos > center > div > div > div > .text {
        width: 300px;
        height: 100%;
        position: absolute;
        z-index: 9999;
        text-align: center;
        left: 0;
        right: 0;
        margin: auto;
    }
    .ofrecemos > center > div > div > .cara > .text > p {
        color: #fff;
        width: 100%;
        padding: 25px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-family: 'JR';
    }
    .cara {
        backface-visibility: hidden;
    }

    .cara.detras {
        margin-left: -333px;
        transform: rotateY(180deg);
    }
    .cobertura-principal {
        width: 100%;
        padding: 0px 300px;
    }
    .cobertura-principal > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
    }
    .cobertura-principal > div {
        display: flex;
        margin-bottom: 50px;
    }
    .cobertura-principal > div > center > img {
        width: 200px;
        height: auto;
    }
    .cobertura-principal > div > div {
        padding: 20px;
    }
    .cobertura-principal > div > div > div > img{
        width: 50px;
        margin-right: 20px;
    }
    .cobertura-principal > div > div > div > label{
        font-family: 'JBD';
        color: #65b24a;
        font-size: 20px;
    }
    .cobertura-principal > div > div > p{
        padding: 25px;
        margin-top: 20px;
        font-family: 'JR';
        -webkit-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        -moz-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
    }
    .cobertura-principal > div > div > p > span{
        font-weight: bold;
    }
    .cobertura-principal-slide{
        padding: 0px 300px;
    }
    .cobertura-principal-slide > div {
        display: flex;
    }
    .cobertura-principal-slide > div > label {
        color: #65b24a;
        font-family: 'JBD';
        font-size: 20px;
    }
    .cobertura-principal-slide > div > img {
        width: 50px;
    }
    .cobertura-principal-slide > p {
        font-family: 'JR';
        margin-top: 10px;
        margin-bottom: 60px;
    }
    .slide-cobertura-opcional > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .opcionales {
        padding: 50px 300px;
        font-family: 'JR';
    }
    .opcionales > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-bottom: 20px;
    }
    .opcionales > .opcional > .subopcional {
        padding-left: 50px;
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }
    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    .move > center > img {
        margin-top: 30px;
        width: 800px;
    }
    @media (max-width: 1500px) {
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .services {
            padding: 50px 200px;
            width: 100%;
        }
    }
    @media (max-width: 1400px) {
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .ofrecemos > center > div > div {
            display: block;
            float: none;
            width: 100%;
        }
        .cara.detras {
            margin-top: -266.92px;
            margin-left: 0px;
        }
        .ofrecemos > center > div > div > div > .text {
            width: 100%;
        }
        .ofrecemos > center > div > div > .cara > .text > p {
            width: 300px;
        }
    }
    @media (max-width: 1300px) {
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .services {
            padding: 50px 50px;
            width: 100%;
        }
        .texto {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal-slide{
            padding: 0px 200px;
        }
        .opcionales {
            padding: 50px 200px;
        }
    }
    @media (max-width: 1200px) {
        .service {
            padding: 20px 75px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 10%;
        }
    }
    @media (max-width: 1100px) {
        .service {
            padding: 20px 50px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 5%;
        }
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            padding: 10px;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .texto {
            width: 100%;
            padding: 10px 100px;
        }
        .services {
            padding: 0px 50px;
        }
        .service {
            padding: 20px 25px;
            width: 100%;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 100px;
        }
        .cobertura-principal-slide{
            padding: 0px 100px;
        }
        .opcionales {
            padding: 50px 100px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
        .move > center > img {
            width: 700px;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .service > div {
            display: grid;
        }
        .service > div > .box{
            margin-left: 0px;
            margin-top: 0px;
            width: 100%;
            padding: 30px 30px 30px 30px;
        }
        .service > div > .box2 {
            margin-right: 0px;
            margin-top: 0px;
            background-color: #fff;
            width: 100%;
            padding: 30px 30px 100px 30px;
        }
        .service > div > .imgbox {
            display: block;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .service > div > .imgbox > img{
            width: 250px;
            margin: auto;
        }
        .service > div > .right{
            position: relative;
            right: 0px;
        }
        .service > div > .box2 > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .service > div > .box > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .cobertura-principal > div {
            display: block;
        }
        .move > center > img {
            width: 600px;
        }
    }
    @media (max-width: 700px) {
        .texto {
            width: 100%;
            padding: 10px 50px;
        }
        .cobertura-principal {
            padding: 10px 50px;
        }
        .cobertura-principal-slide {
            padding: 0px 50px;
        }
        .opcionales {
            padding: 50px 50px;
        }
        .move > center > img {
            width: 500px;
        }
    }
    @media (max-width: 600px) {
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
        .move > center > img {
            width: 400px;
        }
    }
    @media (max-width: 500px) {
        .texto > .box-title > h1 {
            font-size: 30px;
        }
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 25px;
        }
        .services > center > div > div {
            width: 80%;
        }
        .slide-cobertura-opcional > center > h1 {
            font-size: 30px;
        }
        .cobertura-principal > center > h1{
            font-size: 30px;
        }
        .opcionales > center > h1 {
            font-size: 30px;
        }
        .move > center > img {
            width: 300px;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
        .connect > p{
            padding-left: 5px;
            font-size: 16px;
            line-height: 19px;
        }
        .move > center > img {
            width: 250px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosEmpresas/SeguroColectivoVida.vue